import React, { useCallback, useEffect, useState } from 'react'
import LoginCommonOutline from './LoginCommonOutline';
import { useTranslation } from 'react-i18next';
import { Button } from 'primereact/button';
import { Link, useNavigate } from 'react-router-dom';
import { FormInput } from '../../components/FormInput';
import { useForm } from 'react-hook-form';
import { F0020201Before, F0020202Before, forgotAccOrPwd, verifyOPTCode } from '../../utility/service/register-service';
import { checkDpSuccess, loginClientId } from '../../utility/service/tool-service';
import { AlertService } from '../../utility/service/alert-service';
import CountdownTimer from '../../components/CountdownTimer';
import CompanyRoleSelector from "../../components/layout/CompanyRoleSelector"
import { addFormValidator } from '../../utility/validate/formValidator';
import { TabPanel, TabView } from 'primereact/tabview';

const ForgetAccPwd = () => {
  const { t } = useTranslation();
  const [tagValue, setTagValue] = useState(0);
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(0);
  const [showTimer,setShowTimer] = useState(false);
  const [countDown,setCountDown] = useState(180);
  const [formRule, setFormRule] = useState([]); //表單驗證


  const handleTagChange = (newValue) => {
    if(activeIndex===1){
      return
    }else{
      setTagValue(newValue);//0,1
    }
  };


  const {
    register,
    handleSubmit,
    watch,
    getValues,
    setValue,
    control,
    clearErrors,
    formState: { errors }
  } = useForm({
    defaultValues: {
      email: ''
    },
    //錯誤驗證時機
    mode: 'all'
  });

  useEffect(()=>{
    axios_getEmailValidBefore();
  },[])

  //建立前查詢form 規則
  const axios_getEmailValidBefore = ()=>{
    F0020201Before()
      .then((res)=>{
          if(checkDpSuccess(res)){
              let array = []
              res?.data?.RespBody?.constraints?.forEach((item) => {
                  const result = addFormValidator(item?.field, res.data.RespBody.constraints);
                  array.push(result)
              })
              setFormRule(array);
          }
      })
  }

  const axios_getOTPValidBefore = ()=>{
    F0020202Before()
      .then((res)=>{
          if(checkDpSuccess(res)){
              let array = []
              res?.data?.RespBody?.constraints?.forEach((item) => {
                  const result = addFormValidator(item?.field, res.data.RespBody.constraints);
                  array.push(result)
              })
              setFormRule(array);
          }
      })
  }

const setValidForm = useCallback((formId) => {
    if (formRule?.length > 0) {
        const tmp = formRule?.find((item) => {
            return Object.keys(item)[0] === formId
        });
        return tmp ? tmp[formId] : '';
    }
}, [formRule]);


  const onSubmit = (data)=>{    
    if(activeIndex===0){ //第一步驗證email
      axios_forgotAccOrPwd({
        email:data.email,
        isForgetAcct:tagValue===0?'Y':'N'
      })

    }else{ //驗證OPT碼
      let themeColorSession = sessionStorage?.getItem("loadTheme")!=="undefined"&&sessionStorage?.getItem("loadTheme")!==null?sessionStorage?.getItem("loadTheme"):'green';

      verifyOPTCode({
        email:data.email,
        otpCode:data.otpCode,
        audience:loginClientId(themeColorSession) 
      })
        .then((res)=>{
          if(checkDpSuccess(res)){
            setCountDown(0);
            setShowTimer(false);
            AlertService.ok(t('otpVerifySuccess',{email:res.data.RespBody?.email}));
            navigate('/login')

          }
        })
    }

  }

  const  axios_forgotAccOrPwd = (reqBody)=>{
    let themeColorSession = sessionStorage?.getItem("loadTheme")!=="undefined"&&sessionStorage?.getItem("loadTheme")!==null?sessionStorage?.getItem("loadTheme"):'green';
    reqBody.audience = loginClientId(themeColorSession)
    forgotAccOrPwd(reqBody)
      .then((res)=>{
        if(checkDpSuccess(res)){
          setActiveIndex(1);
          setValue("otpCode","");
          setShowTimer(true);
          AlertService.ok(t('sendOtpToEmail',{email:res.data.RespBody?.email}));
          axios_getOTPValidBefore();//OTP驗證碼 統一檢核
        }
      })

  }

  const onRoleChange = (newColor, hasChanged)=>{
    if(hasChanged){
      setValue("email","");
      clearErrors();
    }
  }

  const tabPanelContent = ()=>{
    return (
      <>
         {
        activeIndex ===0 ?(
          <>
          <div className='col-12'>
            <p className='mt-3'>{t('plz_enter_saved_email')}</p>
          </div>
          <div className="col-12">
            <FormInput
              labelClass="required"
              withLabel={true}
              register={register}
              errors={errors}
              id="email"
              labelText={t('companyEamil')}
              type="text"
              rules={setValidForm("email")}
              placeholder={`Email`}
            />
          </div>
          <div className='col-12 flex-all-center gap-2'>
            <Button size='small' className='w-100' onClick={() => { navigate('/login') }} label={t("button.back")} outlined />
            <Button size='small' className='w-100' type='submit' label={t("button.next_step")} />
          </div>
          </>

        ):(
          <>
          <div className='col-12'>
            <p className='mt-3'>{t('otpHint')} {getValues('email')}</p>
          </div>
          <div className="col-12">
            {
              showTimer && (
                <CountdownTimer setRemainingSeconds={setCountDown} remainingSeconds={countDown} />
              )
            }
          </div>
          <div className="col-12">
            <FormInput
              labelClass='required'
              withLabel={true}
              register={register}
              errors={errors}
              id="otpCode"
              name="otpCode"
              labelText={t('otpCode')}
              type="text"
              rules={setValidForm("otpCode")}
            />
          </div>
          <div className="col-12 flex-all-center gap-2">

            
            {
              countDown === 0?(
                <Link type='button' outlined onClick={()=>{
                  axios_forgotAccOrPwd({
                    email:getValues("email"),
                    isForgetAcct:tagValue===0?'Y':'N'
                  });
                  setCountDown(180);
                  setValue("otpCode","");
               }}>
               {t('regetOtpCode')}
                </Link> 
              ):(
            <Link style={{cursor:"auto"}}>{t('regetOtpCodeCountDown',{count:countDown})} </Link>
              )
            }
       
          </div>
          <div className='col-12 flex-all-center gap-2'>
            <Button disabled={getValues('otpCode')===''} size="small" type='submit' className='w-100' label={t("button.send")} />
          </div>
        </>
        ) 
      }
      </>
    )
  }

  return (
    <LoginCommonOutline
      pageTitle={t('forget_acc_pwd')}>
      <CompanyRoleSelector onRoleChange={onRoleChange} disabled={activeIndex===1 } />
      <form className='main-form' onSubmit={handleSubmit(onSubmit)}>
      <TabView className='forget-pwd-tab' renderActiveOnly={true} activeIndex={tagValue} onTabChange={(e) => handleTagChange(e.index)}>
        <TabPanel header={t('forget_acc')} rightIcon="pi pi-user ml-2">
          {tabPanelContent()}
        </TabPanel>

        <TabPanel  header={t('forget_pwd')} rightIcon="pi pi-key ml-2">
          {tabPanelContent()}
        </TabPanel>

      </TabView>
      </form>
      

     
    </LoginCommonOutline>
  )
}

export default ForgetAccPwd;